import * as server from "@/utils/http"

export const _page = params => server.get("/students/page", params);
export const _get = params => server.get("/students/get", params);
export const _upload = params => server.postfrom("/students/upload", params);
export const _template=params=>server.download('/students/template',params);
export const _updateStatus = params => server.get("/students/updateStatus", params);
export const _save = params => server.post(params.id ? "/students/update" : "/students/save", params);

